import { locale } from '@/lib/i18n';

/**
 * https://deskworks.ai (and www) shows the landing page, the app lives on app.deskworks.ai. Both are this
 * web app (infra/k8s/chart `landingHosts`), told apart by the host name.
 */
const LANDING_HOSTS = new Set(['deskworks.ai', 'www.deskworks.ai']);
const APP_ORIGIN = 'https://app.deskworks.ai';
/** Pages the landing host shows itself instead of sending them to the app. */
const LANDING_PATHS = new Set(['/', '/privacy', '/terms-and-conditions']);

export function isLandingHost(): boolean {
  return LANDING_HOSTS.has(window.location.hostname);
}

/** mcp.deskworks.ai is Deskworks's MCP server for Claude, ChatGPT & co. (chart value `mcpHost`): its pages are the app's. */
export function isMcpHost(): boolean {
  return window.location.hostname === 'mcp.deskworks.ai';
}

/** A path deskworks.ai serves itself: the landing page and the legal pages. */
export function isLandingPath(pathname: string): boolean {
  return LANDING_PATHS.has(pathname.replace(/(.)\/+$/, '$1'));
}

/**
 * A path of the app: on the landing and the MCP host it points to app.deskworks.ai, everywhere else it stays relative.
 * The app is another origin, so the page's language goes along as `?lang=` (src/lib/i18n.tsx).
 */
export function appUrl(path: string): string {
  if (!isLandingHost() && !isMcpHost()) return path;
  const url = new URL(path, APP_ORIGIN);
  url.searchParams.set('lang', locale);
  return url.href;
}
